/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

interface Props {
  height?: number,
  width?: number,
  uri: string;
  styles?: any
}

const Image: React.FC<Props> = ({
  uri, height,
}) => {
  const getImage = (item: string): string => {
    if (item.includes('https') || item.includes('http')) {
      return item;
    }
    return item;
  };

  return (
    <LazyLoadImage
      alt="Imagem não carregou"
      height={height}
      src={getImage(uri)}
      style={{ height: 'auto', width: '100%' }}
    />
  );
};

export default Image;
